import { IconTextButton } from "@smartsuite/react-ui/lib/components/buttons/IconTextButton/IconTextButton";
import type { TextStyleType } from "@smartsuite/react-ui/lib/components/buttons/IconTextButton/IconTextButton.constants";
import { Text } from "@smartsuite/react-ui/lib/components/typography/Text/Text";
import { Colors, TextColorNames } from "@smartsuite/types";
import cx from "classnames";
import React, { type FunctionComponent, memo } from "react";

const textStyle: TextStyleType = {
  size: "s",
  color: TextColorNames.primary,
};

const iconStyle = {
  marginRight: 6,
  color: Colors.dGrey,
};

interface SidebarSelectSettingsButtonProps {
  badgeValue: number;
  label: string;
  iconName: string;

  onClick: () => void;
}

const SidebarSelectSettingsButtonRaw: FunctionComponent<
  SidebarSelectSettingsButtonProps
> = ({ label, badgeValue, iconName, onClick }) => {
  return (
    <IconTextButton
      className={cx(
        "sidebar-button-icon sidebar-button-icon--light",
        !!badgeValue && "sidebar-button-icon__has_badge",
      )}
      iconName={iconName}
      textStyle={textStyle}
      iconStyle={iconStyle}
      onClick={onClick}
    >
      {label}

      {!!badgeValue && (
        <Text
          size="xs"
          color="currentColor"
          weight="bold"
          className="sidebar-button-icon__badge"
          dataTestId="sidebar-button-icon__badge"
        >
          {badgeValue}
        </Text>
      )}
    </IconTextButton>
  );
};

export const SidebarSelectSettingsButton = memo(SidebarSelectSettingsButtonRaw);
